import { render, staticRenderFns } from "./InstitutionalMenu.vue?vue&type=template&id=40d15a15"
import script from "./InstitutionalMenu.vue?vue&type=script&lang=js"
export * from "./InstitutionalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports